export interface PartnersPromotionsRequest {
  carrierCode: string;
}

export interface PartnersPromotionsResponse {
  loyaltyMemberId: string;
  personName: PersonName;
  eligibleTotalCount: number;
  enrolledTotalCount: number;
  eligiblePromotions: EligiblePromotion[];
  enrolledPromotions: EnrolledPromotion[];
}

export interface PersonName {
  firstName: string;
  middleName: string;
  lastName: string;
}

export interface EligiblePromotion {
  promotionCode: string;
  enrollmentEndDate: string;
  activityStartDate: string;
  activityEndDate: string;
  categoryTypeCode: string;
}

export interface EnrolledPromotion {
  promotionCode: string;
  enrollmentStartDate: string;
  activityStartDate: string;
  activityEndDate: string;
  qualifiedDate: string;
  categoryTypeCode: string;
  trackingIndicatorCode: string;
  completedIndicator: boolean;
  activityCompletedNum: number;
  activityRequiredNum: number;
  rewardsPossibleNum: number;
  rewardsEarnedNum: number;
}

export interface Linked {
  status: boolean;
  date: string;
}

export interface PartnerAnalytics {
  index: number;
  label: string;
  length: number;
  title: string;
  id: string;
  buttonLabel?: string;
}
